import React from 'react';
import results from '../../data/results';

const datacenters = [
  'sfo',
  'jfk',
  'fra',
  'gru',
  'syd',
  'nrt'
];

function classFor(criteria, value) {
  if (criteria[1] < value) {
    return "is-critical";
  } else if (criteria[0] < value) {
    return "is-warning";
  }
  return "is-good";
}

const StatsByServerItem = (props) => {
  const {name, stat} = props;
  const result = results[stat.name];

  return (
    <tr>
      <td>{result.label}</td>
      {datacenters.map((key, index) => {
        let value = stat.locations[key];
        return <td key={index}>
          <div className={classFor(result.criteria, value)}>
            {typeof value === "undefined" ? "–" : value + "ms"}
          </div>
        </td>
      })}
    </tr>
  );
};

StatsByServerItem.propTypes = {
  label: React.PropTypes.string,
  locations: React.PropTypes.object
};

export default StatsByServerItem;



// WEBPACK FOOTER //
// ./src/components/results/StatsByServerItem.js